//路由表
const routerList = [
    {
        path: "/", //路径的别名  唯一
        redirect: '/PersonalBusinessList'
    },
    // {
    //     path: "/Login",
    //     name: "登录",
    //     component: () => import("@/views/Login.vue")
    // },
    {
        path: "/AutoReplay",
        name: "AutoReplay",
        component: () => import("@/views/CustomerService/AutoReplay.vue")
    },
    {
        path: "/Location",
        name: "Location",
        component: () => import("@/views/CustomerService/Location.vue")
    },
    {
        path: "/PersonalBusinessList",
        name: "个人业务列表",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/FunctionList/PersonalBusinessList.vue"),
    },
    {
        path: "/ResidentBusiness",
        name: "个人业务",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/ResidentBusiness/BusinessLayout.vue")
    },
    {
        path: "/CompanyBusinessList",
        name: "单位业务列表",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/FunctionList/CompanyBusinessList.vue")
    },
    {
        path: "/AuthenticationList",
        name: "身份认证",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/FunctionList/AuthenticationList.vue")
    },
    {
        path: "/CompanyBusiness",
        name: "单位业务",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/CompanyBusiness/BusinessLayout.vue")
    },
    {
        path: "/ProgressSearchList",
        name: "进度查询",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/FunctionList/ProgressSearchList.vue")
    },
    {
        path: "/AccountManagementList",
        name: "账号管理",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/FunctionList/AccountManagementList.vue")
    },
    {
        path: "/ComplaintList",
        name: "投诉咨询",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/FunctionList/ComplaintList.vue")
    },
    {
        path: "/BillPaymentList",
        name: "账单缴费",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/FunctionList/BillPaymentList.vue")
    },
    {
        path: "/WaterFee",
        name: "水费查询",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/WaterFee/WaterFee.vue")
    },
    {
        path:"/PublicAnnouncementList",
        name:"通知公告",
        meta: {
            keepAlive: false,
            requireAuth: true
        },
        component: () => import("@/views/FunctionList/PublicAnnouncementList.vue")
    },
    {
        path: "/SalesNetworkList",
        name: "营业网点",
        meta: {
            keepAlive: false,
            requireAuth: true
        },
        component: () => import("@/views/FunctionList/SalesNetworkList.vue")
    },
    {
        path: "/OperationManualList",
        name: "操作手册",
        meta: {
            keepAlive: false,
            requireAuth: true
        },
        component: () => import("@/views/OperationManual/OperationManualList.vue")
    },
    {
        path: "/CidList",
        name: "户号查询",
        meta: {
            keepAlive: false,
            requireAuth: false
        },
        component: () => import("@/views/FunctionList/CidList.vue")
    },
    // {
    //     path: "/Layout",
    //     name: "Layout",
    //     component: () => import("@/components/BaseLayout/Layout.vue"),
    //     meta: {
    //         keepAlive: true,
    //         requireAuth: false
    //     },
    //     children: [
    //
    //         ]
    // }
];

export default routerList
